import { AnyAction, combineReducers, Reducer } from '@reduxjs/toolkit';

import agencyDocuments from './agency-documents';
import agencyInspectorsProfiles from './agency-inspectors-profiles';
import agencyLeads from './agency-leads';
import agencyOnboarding from './agency-onboarding';
import agencyReports from './agency-reports';
import agencyReviews from './agency-reviews';
import auth from './auth';
import clientBookings from './client-bookings';
import clientCompany from './client-company';
import clientJobs from './client-jobs';
import clientOnboarding from './client-onboarding';
import clientReports from './client-reports';
import constants from './constants';
import csvReports from './csv-reports';
import dcraInspectionEvents from './dcra-inspections/inspection-events';
import inspections from './dcra-inspections/inspections';
import inspectors from './dcra-inspections/inspectors';
import inspectorsAvailability from './dcra-inspections/inspectors-availability';
import emailVerification from './email-verification';
import employees from './employees';
import inspectionEvents from './inspection-events';
import invitations from './invitations';
import messaging from './messaging';
import ui from './ui';

const combinedReducer = combineReducers({
  agencyDocuments,
  agencyLeads,
  agencyOnboarding,
  agencyInspectorsProfiles,
  agencyReports,
  agencyReviews,
  auth,
  clientBookings,
  clientCompany,
  invitations,
  clientJobs,
  clientOnboarding,
  clientReports,
  constants,
  emailVerification,
  employees,
  messaging,
  ui,
  csvReports,
  inspectorsAvailability,
  inspections,
  inspectors,
  inspectionEvents,
  dcraInspectionEvents,
});

export type RootState = ReturnType<typeof rootReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === 'auth/logout') {
    state = {} as RootState;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
